"use client"
import { CompletedShipmentProof } from "@/components/CompletedShipmentStat"

import Image from "next/image"
import bbbRating from "../../assets/images/bbb-rating.webp"
import { Anchor } from "../../app/components/anchor"
import { PreferredSourceButton } from "../preferred-source-button"
import {
  TERMS_OF_SERVICE_URL,
  PRIVACY_POLICY_URL,
  COPYRIGHT_YEAR,
} from "../../constants/brand"

const Footer = () => {
  const handleRevisitConsent = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    try {
      // @ts-ignore - global from consent manager
      if (
        typeof window !== "undefined" &&
        typeof (window as any).revisitCkyConsent === "function"
      ) {
        ;(window as any).revisitCkyConsent()
      }
    } catch (_) {}
  }

  return (
    <section
      id="premium-footer"
      className="font-inter flex flex-col md:flex-row justify-between gap-8 py-4 max-w-7xl mx-auto border-t mt-12 md:mt-24 pt-8 px-6"
    >
      <div className="pt-6">
        <CompletedShipmentProof />
        <div className="flex gap-8 mb-4 text-md">
          <Anchor href={TERMS_OF_SERVICE_URL}>Terms and Conditions</Anchor>
          <Anchor href={PRIVACY_POLICY_URL}>Privacy Policy</Anchor>
          <Anchor href="#" prefetch={false} onClick={handleRevisitConsent}>
            Do Not Sell or Share My Personal Information
          </Anchor>
        </div>
        <p>&#169; {COPYRIGHT_YEAR} CitizenShipper. All Rights Reserved.</p>
        <PreferredSourceButton className="mt-4" />
      </div>
      <div className="font-inter flex flex-row justify-between items-center gap-2 md:gap-10 ">
        <Image
          src="/icons/powered-by-stripe.webp"
          alt="stripe"
          width="150"
          height="30"
          loading="lazy"
          className="w-[150px] h-[30px]"
        />

        <Image
          src={bbbRating.src}
          alt="CitizenShipper is a BBB Accredited Business."
          width="135"
          height="40"
          className="w-[135px] h-[40px]"
          loading="lazy"
        />
      </div>
    </section>
  )
}

export default Footer
